import { Reducer } from 'redux'

export enum CloudFaasOnboardingActionTypes {
  SET_ERROR = 'SET_ERROR',
  SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS',
  SHOW_MODAL = 'SHOW_MODAL',
  CLEAR_MODAL = 'CLEAR_MODAL',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',
  ADD_ACCOUNT = 'ADD_ACCOUNT',
  SET_TERMS_ACCEPTED = 'SET_TERMS_ACCEPTED',
  SET_VALIDATION = 'SET_VALIDATION',
  SET_ONBOARDING_COMPLETE = 'SET_ONBOARDING_COMPLETE',
}

export interface AWSAccountTableDetails {
  id: string
  createdAt: string
  updatedAt?: string
  sellerId?: string
  awsAccountId: string
  accountName: string
  role: string
}
export interface AwsAccountsState {
  loading?: boolean
  error?: string
  hasMore?: boolean
  showModal?: boolean
  isTermsAccepted?: boolean
  isValidation?: boolean
  onboardingComplete?: boolean
  awsAccountDetails: AWSAccountTableDetails[]
}

type actionType =
  | {
      type: CloudFaasOnboardingActionTypes.SET_ERROR
      payload: string
    }
  | {
      type: CloudFaasOnboardingActionTypes.SET_ACCOUNT_DETAILS
      payload: AWSAccountTableDetails[]
    }
  | {
      type: CloudFaasOnboardingActionTypes.SHOW_MODAL
      payload: boolean
    }
  | {
      type: CloudFaasOnboardingActionTypes.CLEAR_MODAL
    }
  | {
      type: CloudFaasOnboardingActionTypes.SET_TERMS_ACCEPTED
      payload: boolean
    }
  | {
      type: CloudFaasOnboardingActionTypes.SET_VALIDATION
      payload: boolean
    }
  | {
      type: CloudFaasOnboardingActionTypes.SET_ONBOARDING_COMPLETE
      payload: boolean
    }

export const initialState: AwsAccountsState = {
  loading: false,
  error: undefined,
  hasMore: true,
  showModal: false,
  awsAccountDetails: [],
  isTermsAccepted: false,
  isValidation: false,
  onboardingComplete: false,
}

export const reducer: Reducer<AwsAccountsState, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CloudFaasOnboardingActionTypes.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
      }
    }
    case CloudFaasOnboardingActionTypes.SET_ACCOUNT_DETAILS: {
      return {
        ...state,
        awsAccountDetails: action.payload,
      }
    }
    case CloudFaasOnboardingActionTypes.SHOW_MODAL: {
      return {
        ...state,
        showModal: action.payload,
      }
    }
    case CloudFaasOnboardingActionTypes.CLEAR_MODAL: {
      return {
        ...state,
        showModal: false,
      }
    }
    case CloudFaasOnboardingActionTypes.SET_TERMS_ACCEPTED: {
      return {
        ...state,
        isTermsAccepted: action.payload,
      }
    }
    case CloudFaasOnboardingActionTypes.SET_VALIDATION: {
      return {
        ...state,
        isValidation: action.payload,
      }
    }
    case CloudFaasOnboardingActionTypes.SET_ONBOARDING_COMPLETE: {
      return {
        ...state,
        onboardingComplete: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
